import { buildFileUrl } from 'remote/build-file-url';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLottieSource } from 'utils/lottie/use-lottie-source';

import {
  BadgeAnimationSourceResult,
  UseBadgeAnimationSourceOptions,
} from './use-badge-animation-source.types';

export const useBadgeAnimationSource = ({
  lottie,
  showCelebration,
}: UseBadgeAnimationSourceOptions): BadgeAnimationSourceResult => {
  const sanityProjectId = useFlag(LaunchDarklyFlag.SANITY_PROJECT_ID);
  const url = showCelebration && lottie ? buildFileUrl(lottie, sanityProjectId) : undefined;

  return useLottieSource({
    source: url ? { uri: url } : undefined,
    surface: 'loyalty_badge',
  });
};

export type {
  BadgeAnimationSourceResult,
  UseBadgeAnimationSourceOptions,
} from './use-badge-animation-source.types';
